/** React libraries */
import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

/** Custom components types, services */
import { RequestMetadaContext } from "../../logoRequest.Type";

const DescOfProduct: React.FC = () => {
  const { watch, register } = useFormContext();
  const isReadOnly = watch("isReadOnly") ? true : false;
  const rowCount = isReadOnly ? 7 : 3;

  /**
   * Return placeholder value as per state
   */
  const placeHolderValue = () => {
     let pValue = "Add a description...";
     if(isReadOnly){
      pValue = "";
     }
     return pValue;
  }
  
  return (
    <>
      {!isReadOnly && <div className="text-muted"
        style={{ fontSize: "11px", color: "#353535", marginBottom: "5px" }}
      > 
      This trademark approval is based upon the information provided in this form by you, the certificate holder. Trademark approval is not an assurance that the product or the paper used is eligible for labeling or promotion. Your company must review incoming documentation from your supplier(s) for their FSC claim and certificate code. The approval is for the use stated and is invalid if applied to a different product, document, or item.
      </div> }
      <Form.Control
        disabled = {isReadOnly}
        as="textarea"
        rows={rowCount}
        placeholder= {placeHolderValue()}
        {...register("productDescription.description")}
      />
    </>
  );
};

export default DescOfProduct;
